import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import RHService from '../../../../../../services/rh-auth';
import { Link } from 'react-router-dom';
import '../../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [orgao, setOrgao] = useState("");
    const [ano, setAno] = useState("");
    const [anoArq, setAnoArq] = useState("");
    const [referencia, setReferencia] = useState("");



    const busca = async (query) => {
        if (query == "") {
            await props.fetchConcursos()
            setAno("")
            setAnoArq("")
            setOrgao("")
            setReferencia("")
        } else {
            var response = await RHService.buscarConcurso(query)
            if (response.data.length >= 1) {
                props.setConcursos(response.data)
                props.setVazio(false)
                setAno("")
                setAnoArq("")
                setOrgao("")
                setReferencia("")
            } else {
                props.setVazio(true)
                setAno("")
                setAnoArq("")
                setOrgao("")
                setReferencia("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        if (anoArq) prepQuery = prepQuery + `&ano=${anoArq}`;
        if (orgao !== "false" && orgao != "false" && orgao !== "") prepQuery = prepQuery + `&orgao=${encodeURI(orgao)}`;
        if (referencia) prepQuery = prepQuery + `&referencia=${referencia}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano do Concurso"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="orgao">
                                <FloatingLabel
                                    label="orgao"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="orgao"
                                        name="orgao"
                                        onChange={e => setOrgao(e.target.value)}
                                    >
                                        <option>TODOS</option>
                                        <option value="Prefeitura Municipal de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Secretaria Municipal de Saúde">Secretaria Municipal de Saúde</option>
                                        <option value="Secretaria Municipal de Educação">Secretaria Municipal de Educação</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano do Edital de Convocação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={anoArq}
                                        onChange={e => setAnoArq(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/rh/concurso'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
